module.exports = __webpack_public_path__ + "static/media/Statua_051.5dac1850.jpg";